import { lazy } from 'react';
import { V9_JOURNEY_PATH } from '@/services/constants';

const Address = lazy(() => import('@/pages/Address'));
const Contact = lazy(() => import('@/pages/Contact'));
const Info = lazy(() => import('@/pages/Info'));
const SignV9 = lazy(() => import('@/pages/SignV9'));
const FinishScreen = lazy(() => import('@/pages/FinishScreen'));
const CreditCheckEquifax = lazy(() => import('@/pages/CreditReport/credit-report'));
const Experian = lazy(() => import('@/pages/CreditReport/credits-report'));
const Otp = lazy(() => import('@/components/Otp'));
const LuminateIDV = lazy(() => import('@/pages/LuminateIdv'));
const AlreadyFiled = lazy(() => import('@/pages/AlreadyFiled'));
const Viewthru = lazy(() => import('@/pages/CreditReport/creditv-report'));
const CreditHistoryEquifax = lazy(() => import('@/pages/CreditReport/CreditHistoryEquifax'));

const JOURNEY_PAGES: Record<string, { path: string; component: React.ReactNode; title: string }> = {
  ADDRESS: {
    path: `/${V9_JOURNEY_PATH}/address`,
    component: <Address />,
    title: 'Address',
  },
  INFO: {
    path: `/${V9_JOURNEY_PATH}/info`,
    component: <Info showMaidenName />,
    title: 'Info',
  },
  CONTACT: {
    path: `/${V9_JOURNEY_PATH}/contact`,
    component: <Contact />,
    title: 'Contact',
  },
  SIGN_FINAL: {
    path: `/${V9_JOURNEY_PATH}/sign`,
    component: <SignV9 />,
    title: 'Sign',
  },
  EXPERIAN: {
    path: `/${V9_JOURNEY_PATH}/credits-report`,
    component: <Experian />,
    title: 'Credits Report',
  },
  EQUIFAX: {
    path: `/${V9_JOURNEY_PATH}/credit-report`,
    component: <CreditCheckEquifax />,
    title: 'Credit Report',
  },
  EQUIFAX_STEALTH: {
    path: `/${V9_JOURNEY_PATH}/credit-report-s`,
    component: <CreditCheckEquifax stealthMode />,
    title: 'Credit Report',
  },
  VIEW_THRU: {
    path: `/${V9_JOURNEY_PATH}/creditv-report`,
    component: <Viewthru />,
    title: 'Credit Report',
  },
  EQUIFAX_INFO: {
    path: `/${V9_JOURNEY_PATH}/credit-report-eg`,
    component: <CreditHistoryEquifax />,
    title: 'Equifax Report',
  },
  FINISH_SCREEN: {
    path: `/${V9_JOURNEY_PATH}/submit-claim`,
    component: <FinishScreen />,
    title: 'Finish Screen',
  },
  OTP: {
    path: `/${V9_JOURNEY_PATH}/otp`,
    component: <Otp />,
    title: 'OTP',
  },
  LUMINATE_IDV: {
    path: `/${V9_JOURNEY_PATH}/questions`,
    component: <LuminateIDV />,
    title: 'Luminate IDV',
  },
  ALREADY_FILED: {
    path: `/${V9_JOURNEY_PATH}/already-filed`,
    component: <AlreadyFiled />,
    title: 'Already Filed',
  },
};

export default JOURNEY_PAGES;
